<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="backdrop-area" @click="hide()"></div>
            <div class="modal-content">
                <div class="bg-black w-full rounded-xl p-3 text-center text-white bg-opacity-70">
                    Loading...
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import { inject } from "vue";
// import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "LoadingModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            open: false,
            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    setup: function () {
        const localeStore = inject("LocaleStore")

        return {
            lbl: localeStore.lbl
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.busModal.off('show');
        this.busModal.off('hide');
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        show: function () {

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;

            this.$nextTick(() => {
                this.onModalHidden()
            })
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;
}
</style>
    
